import { FC } from 'react';

import { TableContext, TableContextState } from './Table';
import { useColumns } from '../hooks/useColumns';

export const TableContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { columns, gridLayout } = useColumns();

  const context: TableContextState = {
    columns,
    gridLayout,
  };

  return <TableContext.Provider value={context}>{children}</TableContext.Provider>;
};
